import { createAction } from '@reduxjs/toolkit'

export const setupByUrl = createAction<string>('common/setupByUrl')

export const resetAllState = createAction('common/resetState')
